"use client";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { IconPlus } from "@/components/icons";
import type { FaqItem } from "@/content/faq";

/**
 * Accordion list for the FAQ page. Flat styling: a single divider between
 * entries, no elevation, color-only feedback per the design rules.
 */
export function FaqList({ items }: { items: readonly FaqItem[] }) {
  return (
    <div>
      {items.map((item) => (
        <Accordion
          key={item.question}
          elevation={0}
          disableGutters
          square
          sx={{
            backgroundColor: "transparent",
            borderBottom: "1px solid",
            borderColor: "divider",
            "&::before": { display: "none" },
          }}
        >
          <AccordionSummary
            expandIcon={<IconPlus size={18} />}
            sx={{
              px: 0,
              "&:hover": { color: "primary.main" },
              // The plus rotates into a close mark when the entry is open.
              "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
                transform: "rotate(45deg)",
              },
            }}
          >
            <Typography sx={{ fontWeight: 600, fontSize: "1.05rem" }}>
              {item.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ px: 0, pt: 0, pb: 3 }}>
            <Typography sx={{ fontSize: "1rem", lineHeight: 1.7, color: "text.secondary" }}>
              {item.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}
